import { Link, useNavigate } from "react-router-dom";

function Footer() {

  let navigate = useNavigate();

  const FB = () => (
    <img
        src="https://storage.googleapis.com/eggspatzen-data-bucket/facebook.png"
        alt="FB"
        className="footer_icons"
    />
);
const IG = () => (
  <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/instagram.png"
      alt="IG"
      className="footer_icons"
  />
);

const Logo = () => (
  <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/logo-white.svg"
      alt="logo"
      className="footer_logo"
      onClick={() => navigate("/")}
  />
);

  return (
    <div className="Footer col-12">
      <div>
      <Link className="footer_links" to="/impressum">Impressum</Link>
      <Link className="footer_links" to="https://istagram.com/eggspatzen_egweil/">
      {/* <img alt="instagram" src={insta} className="footer_icons"></img> */}
      <IG></IG>
      </Link>
      <Link className="footer_links" to="https://facebook.com/eggspatzen/">
      {/* <img alt="facebook" src={facebook} className="footer_icons"></img> */}
      <FB></FB>
      </Link>
      </div>

      {/* <img alt="Logo" src={logo} className="footer_logo" onClick={() => navigate("/")}></img> */}
      <Logo></Logo>
    </div>
  );
}

export default Footer;